import React from 'react';

export default function LoadingSpinner({ size = 32, color = '#6366f1' }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '3rem' }}>
      <div
        style={{
          width: size,
          height: size,
          border: `3px solid #e2e8f0`,
          borderTop: `3px solid ${color}`,
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
    </div>
  );
}
